import React, { useState } from 'react';
import { StateEnum } from 'constants/state';
import { Form } from 'antd';
import {
  Input,
  Modal,
  Select,
} from 'UI';
import { useDispatch } from 'hooks/store';
import { createClientLocationAction } from 'state/slices/clients';
import { unwrapResult } from '@reduxjs/toolkit';

import {
  FormContainer,
  BaseFormItem,
  AddressInline,
  NotesInline,
  InlineFormGroup,
  InlineButton,
} from './style';

export interface AddClientLocationFormData {
  name?: string
  maintainer?: string
  state?: StateEnum
  city?: string
  phone?: string
  cpf?: string
  cnpj?: string
  stateRegistration?: string
  notes?: string
}

interface LocationModalProps {
  // formHandler: FormInstance
  // onSubmit(data: unknown): void
  clientId: string
  onCancel(): void
  onFinish(): void
  isVisible: boolean
}

const LocationModal = ({
  // formHandler,
  // onSubmit,
  clientId,
  onCancel,
  onFinish,
  isVisible,
}: LocationModalProps): JSX.Element => {
  const [form] = Form.useForm<AddClientLocationFormData>();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  const onSubmit = async (locationData: AddClientLocationFormData) => {
    try {
      setLoading(true);
      const result = await dispatch(createClientLocationAction({
        clientId,
        locationData: {
          ...locationData,
          isActive: true,
        },
      }));
      await unwrapResult(result);
      form.resetFields();
      setLoading(false);
      onFinish();
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={isVisible}
      title="Nova localização"
      destroyOnClose
      onCancel={onCancel}
      afterClose={onCancel}
      zIndex={90}
      footer={[
        <InlineButton
          key="cancel"
          onClick={onCancel}
          type="ghost"
        >
          Cancelar
        </InlineButton>,
        <InlineButton
          key="submit"
          loading={isLoading}
          htmlType="submit"
          onClick={() => form.submit()}
        >
          Salvar localização
        </InlineButton>,
      ]}
    >
      <FormContainer
        layout="vertical"
        form={form}
        requiredMark={false}
        onFinish={onSubmit as (val: unknown) => void}
      >
        <BaseFormItem
          label="Encarregado"
          name="maintainer"
          rules={[
            {
              required: true,
              message: 'Insira um encarregado',
            },
          ]}
        >
          <Input />
        </BaseFormItem>
        <BaseFormItem
          label="Fazenda"
          name="name"
          rules={[
            {
              required: true,
              message: 'Insira um nome',
            },
          ]}
        >
          <Input />
        </BaseFormItem>
        <AddressInline>
          <BaseFormItem
            label="Cidade"
            name="city"
            className="city-input"
            rules={[
              {
                required: true,
                message: 'Insira uma cidade',
              },
            ]}
          >
            <Input />
          </BaseFormItem>
          <BaseFormItem
            label="Estado"
            name="state"
            className="state-input"
            initialValue={StateEnum.AC}
          >
            <Select>
              {Object.values(StateEnum).map((state) => (
                <Select.Option value={state} key={state}>{state}</Select.Option>
              ))}
            </Select>
          </BaseFormItem>
        </AddressInline>
        <BaseFormItem
          label="Telefone"
          name="phone"
        >
          <Input />
        </BaseFormItem>
        <InlineFormGroup>
          <BaseFormItem
            label="CPF"
            name="cpf"
            className="cpf-input"
          >
            <Input />
          </BaseFormItem>
          <BaseFormItem
            label="CNPJ"
            name="cnpj"
            className="cnpj-input"
          >
            <Input />
          </BaseFormItem>
        </InlineFormGroup>
        <BaseFormItem
          label="Inscrição estadual"
          name="stateRegistration"
        >
          <Input />
        </BaseFormItem>
        <NotesInline
          label="Observações"
          name="notes"
        >
          <Input.TextArea rows={5} />
        </NotesInline>
      </FormContainer>
    </Modal>
  );
};

export default LocationModal;
